module.exports = __webpack_public_path__ + "img/ホーム-active.01f83d32.svg";